import React from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import HowItWorks from '../components/HowItWorks';
import YouTubeBanner from '../components/YouTubeBanner';
import Features from '../components/Features';

/**
 * Home Page Component
 * Main landing page containing Hero, How It Works, Screenshots, and Features sections
 * Includes SEO meta tags for optimal search engine visibility
 */
function Home() {
  return (
    <div>
      {/* SEO Meta Tags */}
      <SEO 
        title="lockitup – Protect Your Laptop Before Repair"
        description="lockitup is free software to lock your laptop before repair. Protect personal files, photos, and data with one-click secure locking. Completely free and offline."
        keywords="laptop lock software, protect laptop before repair, data privacy, secure laptop, free lock software"
        ogTitle="lockitup – Protect Your Laptop Before Repair"
        ogDescription="Free laptop locking software to keep your personal data safe when giving your device for repair."
        ogUrl="https://www.lockitup.tech"
      />
      
      {/* Hero Section - Top of page with main CTA and Download button */}
      <HeroSection />
      
      {/* How It Works - 3-step guide */}
      <HowItWorks />
      
      {/* YouTube Banner - Link to YouTube channel */}
      <YouTubeBanner />
      
      {/* Features Section - Product capabilities */}
      <Features />
    </div>
  );
}

export default Home;
